import React, { useState, useEffect } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
// util
import { intervalToDuration, parse, isBefore } from 'date-fns'
import { addZero } from '@/util'
import { values } from 'lodash'
// 样式
import style from './CountDown.module.scss'

const defaultStartTime = {
  days: '',
  hours: '',
  minutes: '',
  seconds: '',
}

const getTimeState = (startTime, endTime) => {
  return isBefore(
    parse(endTime, 'yyyy-MM-dd HH:mm:ss', new Date()),
    startTime,
  )
}

const DEFAULTENDTEXT = '已结束'

const CountDown = (props) => {
  const { startTime = new Date(), prefixText = '距结束还剩', afterText = '', endTime, style, extraClassName = '', overText = '', timeType = 'type1', extraClass = '', endClass = '' } = props
  const [during, setDuring] = useState(defaultStartTime)
  const [endText, setEndText] = useState(overText || DEFAULTENDTEXT)
  const [isEnd, setEnd] = useState(getTimeState(startTime, endTime))

  // 设置倒计时结束显示
  const setEndStatus = () => {
    setEnd(true)
    setEndText(overText || DEFAULTENDTEXT)
  }

  useEffect(() => {
    // 没有结束时间则直接返回
    if (!endTime) return
    if ( isEnd ) {
      setEndStatus()
      return
    }
    // 如果时间已经很结束或者传入的时间为假值，则显示结束文案
    let interval = null
    // 倒计时
    const timeHandler = () => {
      const curTimer = endTime && intervalToDuration({
        start: new Date(),
        end: parse(endTime, 'yyyy-MM-dd HH:mm:ss', new Date()),
        referenceDate: 1,
      })
      const curTimerValueArray = values(curTimer) || []
      const timeTotal = curTimerValueArray.reduce((n, m) => n + m)

      // 如果倒计时结束则停止计时器
      if (timeTotal === 0) {
        clearInterval(interval)
        setEndStatus()
      }
      setDuring(curTimer)
    }
    timeHandler()
    // 使用setInterval
    interval = setInterval(() => {
      timeHandler()
      return () => clearInterval(interval)
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [endTime])

  // 倒计时展示形式
  const getTimeText = () => {
    // timeType 参数说明
    // type1: 2天08:54:17   type2: 05天12小时23分52秒

    let res = <div styleName="box">
      <>
        {!!during.days && (<><span styleName="value">{during.days}</span>天</>)}
        <span styleName="value">{addZero(during.hours)}</span>:
        <span styleName="value">{addZero(during.minutes)}</span>:
        <span styleName="value">{addZero(during.seconds)}</span>
      </>
    </div>
    if (timeType === 'type2') {
      res = addZero(during.days) + '天' + addZero(during.hours) + '小时' + addZero(during.minutes) + '分' + addZero(during.seconds) + '秒'
    }
    return res
  }

  return <div className={`${extraClass} ${isEnd ? endClass : ''}`}
      style={style}
      styleName={classNames({
      'timer': true,
      [`theme_${extraClassName}`]: extraClassName !== '',
    })}>
    {
      (isEnd) ?
        <>{endText}</> :
        <>
          {
            during.seconds !== '' && <>
              <p styleName="lable">{prefixText}</p>
              {getTimeText()}
              <p styleName="lable">{afterText}</p>
            </>
          }
        </>
    }
  </div>
}

export default CSSModules(CountDown, style, { allowMultiple: true })